import { HelpCircle } from "@repo/icons";
import type { ReactNode } from "react";

interface DashboardSectionHeaderProps {
  children: ReactNode;
  onClick: (open: boolean) => void;
  statusBadge?: ReactNode;
}

export const DashboardSectionHeader = ({
  children,
  onClick,
  statusBadge,
}: DashboardSectionHeaderProps): JSX.Element => {
  return (
    <div className="flex flex-row items-center justify-between">
      <div className="flex flex-col gap-1">
        <h2 className="font-medium text-neutral-600 text-md">{children}</h2>
        <button
          className="flex items-center gap-2 font-medium text-sm text-secondary-400 self-start underline"
          onClick={() => {
            onClick(true);
          }}
          type="button"
        >
          O que é isso
          <HelpCircle className="w-4 h-4 fill-secondary-400 mb-0.5" />
        </button>
      </div>

      {statusBadge ? <div>{statusBadge}</div> : null}
    </div>
  );
};
